module.exports = __webpack_public_path__ + "static/media/easypanel.f0f3e42c.svg";